import React from 'react';
import SetupConnectObjectPage from './SetupConnectObjectPage';

const SetupUserHierarchyGroupPage = () => (
  <SetupConnectObjectPage
    pageTitle="Setup User Hierarchy Group"
    pageSubtitle="Upload JSON to create user hierarchy groups for a selected Amazon Connect instance"
    objectLabel="User Hierarchy Group"
    endpointKey="userHierarchyGroupApi"
    presignType="user-hierarchy-group"
    sampleFile="sample_user_hierarchy_group_upload.json"
    acceptedKeys={["user_hierarchy_groups", "items"]}
    requiredFields={["Name"]}
  />
);

export default SetupUserHierarchyGroupPage;
